import { FC } from "react";
import { Box, Stack, useMediaQuery } from "@chakra-ui/react";

import { isStringWithNumber } from "../../../../../utils";
import { formatPriceWithoutZeros } from "../../../../../utils";
import { ExpandableBox } from "../../../../shared/ExpandableBox";
import { IScheduleItem } from "../../../../../api/schedule/types.ts";
import { ScheduleItemDetailsText } from "./ScheduleItemDetailsText.tsx";

interface Props {
  showDetails: boolean;
  payment: IScheduleItem;
}

export const ScheduleItemDetails: FC<Props> = ({ showDetails, payment }) => {
  const [isSmallScreen] = useMediaQuery("(max-width: 355px)");

  const rawTotalRest = payment.after?.principal?.total;
  const totalRest = isStringWithNumber(rawTotalRest) ? formatPriceWithoutZeros(Number(rawTotalRest)) : "";

  const rawPrincipal = payment.status === "PAID" ? payment.principal?.paid : payment.principal?.total;
  const principal = isStringWithNumber(rawPrincipal) ? formatPriceWithoutZeros(Number(rawPrincipal)) : "";

  const rawInterest = payment.status === "PAID" ? payment.interest?.paid : payment.interest?.total;
  const interest = isStringWithNumber(rawInterest) ? formatPriceWithoutZeros(Number(rawInterest)) : "";

  return (
    <ExpandableBox show={showDetails}>
      <Stack spacing={0} mt={isSmallScreen ? "10px" : "22px"}>
        {totalRest && (
          <Box mt="3px" mb="4px" px="9px">
            <ScheduleItemDetailsText title="Остаток основного долга после платежа" amount={totalRest} />
          </Box>
        )}

        <Box borderTop="1px dashed" borderTopColor="gray.600" pt="9px" px="6px" mx="3px" mb="4px">
          <ScheduleItemDetailsText title="Основной долг" amount={principal} />
          <ScheduleItemDetailsText title="Проценты" amount={interest} />
        </Box>
      </Stack>
    </ExpandableBox>
  );
};
